module.exports = __webpack_public_path__ + "static/media/S3N2-5.f707012e.svg";